import FetchAjax from "../FetchAjax";
import SystemConfig, {CONFIG_PARAMS, GAMECONF_PARAMS} from "../../system/SystemConfig";
import {FETCH_TYPES, parseURL} from "../Connect";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import IConnectControl from "../controllers/IConnectControl";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";

@injectable()
export default class ConnectAjaxEnd extends AbstractConnect {

    public readonly fetchType: string = FETCH_TYPES.UPDATE;
    timeout: number = 20000;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
        @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
    ) {
        super(config, control, fetch, dom);

        // use gameconf connect timeout if set,
        if (this.config.get(CONFIG_PARAMS.TIMEOUTS) && this.config.get(CONFIG_PARAMS.TIMEOUTS).end > 0) {
            this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).end * 1000;
            // @ts-ignore
            super.ajaxLoadingTimeout = this.timeout /9;
        }
        this.setMethod(this.config.get(CONFIG_PARAMS.URL_UPDATE_METHOD));
    }

    async fetch(data) {
        this.control.reset();
        this.data = data;

        this.initTimeoutLoading();

        return this._fetch();
    }

    protected getParams(): Record<string, any> {

        let params = {
            "casino_id": this.data.casinoId,
            "session_id": this.data.sessionId,
            "round_id": this.data.roundId,
            "ended": this.data.ended ? "true" : "false",
            "fs_win": undefined,
            "fs_count": undefined,
            "fs_order": undefined,
            "reels_stop_enforced": this.data.reels_stop_enforced
        };

        if(this.data.fsCount != null) {
            params.fs_win = this.data.fsWin;
            params.fs_count = this.data.fsCount;
            params.fs_order = this.data.fsOrder
        }

        return params;
    }

    protected getUrl(): string {
        return parseURL(this.config.get(CONFIG_PARAMS.URL_UPDATE), {
            "server_api": this.data.serverApi,
            "casino_id": this.data.casinoId,
            "session_id": this.data.sessionId,
            "round_id": this.data.roundId,
        });
    }
}
